import { generateFilledPdf } from './esfFillable';
import { API_BASE } from './apiBase';

export const ESF_KATEGORIE = 'ESF Fragebogen';

/**
 * Füllt den ESF-Fragebogen mit den angekreuzten Feldern und hängt ihn an den Bericht.
 * Eine vorhandene ESF-Datei wird ersetzt (es gibt je Bericht genau einen Fragebogen).
 * Genutzt vom Formular (/esf-ausfuellen) und von „Vorlage übernehmen" im Editor.
 */
export async function esfAnBerichtHaengen(reportId: number | string, selections: string[]): Promise<{ id: number }> {
  const token = localStorage.getItem('auth_token');
  const authHeaders: Record<string, string> = token ? { Authorization: `Bearer ${token}` } : {};

  const existingRes = await fetch(`${API_BASE}/api/reports/${reportId}/files`, { headers: authHeaders });
  if (existingRes.ok) {
    const existingFiles: { id: number; category: string }[] = await existingRes.json();
    for (const f of existingFiles.filter((f) => f.category === ESF_KATEGORIE)) {
      await fetch(`${API_BASE}/api/files/${f.id}`, { method: 'DELETE', headers: authHeaders });
    }
  }

  const pdfBytes = await generateFilledPdf(selections);
  const formData = new FormData();
  formData.append('file', new Blob([pdfBytes as BlobPart], { type: 'application/pdf' }), 'Fragebogen_ESF_Plus_ausgefuellt.pdf');
  formData.append('category', ESF_KATEGORIE);
  formData.append('esfSelections', JSON.stringify(selections));

  const res = await fetch(`${API_BASE}/api/reports/${reportId}/files`, { method: 'POST', headers: authHeaders, body: formData });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body.message ?? `HTTP ${res.status}`);
  }
  return res.json();
}
